<script>
import Loader from './Loader.vue';
import SwitchButton from '../components/SwitchButton';

/**
 * Edit Deal Modal.
 * Made using https://vuejs.org/v2/examples/modal.html
 */
export default {
    components: { Loader, SwitchButton },
    props: { deal: Object },

    data() {
        return {
            isLoading: false,
            reasons: [],
            selectedReason: 1,
            freeDelivery: false,
            freeDeliveryWithMembership: false,
            clickAndCollect: false,
            categories: [],
        };
    },

    async created() {
        if (this.deal.collection_charge == 1) {
            this.freeDeliveryWithMembership = true;
        }

        if (this.deal.collection_charge == -1) {
            this.freeDelivery=true;
        }

        if (this.deal.click_and_collect == true) {
            this.clickAndCollect = true;
        }

        this.categories = await this.getCategories();
    },

    methods: {
        
        /**
         * Submit the deal to the portal
         */
        async editDeal() {
            this.isLoading = true;

            // Set collection_charge as 1 if free delivery with membership
            if (this.freeDeliveryWithMembership) {
                this.deal.collection_charge = 1;
            } else {
                this.deal.collection_charge = 0;
            }

            // Set collection_charge as -1 if free delivery for all.
            if (this.freeDelivery) {
                this.deal.collection_charge = -1;
            }

            if (this.clickAndCollect) {
                this.deal.click_and_collect = true;
            } else {
                this.deal.click_and_collect = false;
            }


            try {
                const formData = new FormData();
                Object.keys(this.deal).forEach((key) => formData.append(key, this.deal[key]));

                const response = await window.axios.patch(
                    '/api/deals/' + this.deal.id,
                    this.deal,
                );
                
            } catch (error) {

                for (let err in error.response.data.errors) {
                    Vue.toasted.show(
                        error.response.data.errors[err], 
                        { duration: 6000, icon: 'error' },
                    );
                }

            } finally {
                this.isLoading = false;
                let title = this.deal.title.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();

                this.$router.push(`/deal/${this.deal.id}/${title}?key=${Math.floor(Math.random() * 100)}`);
            }
        },

        async getCategories() {
			const response = await window.axios.get('/api/categories/');
            return response.data.data;
		},

        setCategory(id) {
            this.deal.category_id = id;
        },
    },
};
</script>

<template lang='pug' src='./template/EditDealModal.pug'></template>
<style lang='stylus' src='./styles/EditDealModal.styl' scoped></style>
